import PaymentRequests from "./components/PaymentRequest";

export default function MyPaymentRequestsPage() {
  return <PaymentRequests />;
}
